/**
 * @generated SignedSource<<2f2080d80ff376f4bc242992d45cc106>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteVideoInput = {
  clientMutationId?: string | null | undefined;
  videoId?: string | null | undefined;
  videoRawId?: number | null | undefined;
};
export type RemoveVideoButton_DeleteVideoMutation$variables = {
  input: DeleteVideoInput;
};
export type RemoveVideoButton_DeleteVideoMutation$data = {
  readonly deleteVideo: {
    readonly video: {
      readonly rawId: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type RemoveVideoButton_DeleteVideoMutation = {
  response: RemoveVideoButton_DeleteVideoMutation$data;
  variables: RemoveVideoButton_DeleteVideoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveVideoButton_DeleteVideoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVideoPayload",
        "kind": "LinkedField",
        "name": "deleteVideo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveVideoButton_DeleteVideoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVideoPayload",
        "kind": "LinkedField",
        "name": "deleteVideo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "148b4ec51d88084691a338dc2c565bf4",
    "id": null,
    "metadata": {},
    "name": "RemoveVideoButton_DeleteVideoMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveVideoButton_DeleteVideoMutation(\n  $input: DeleteVideoInput!\n) {\n  deleteVideo(input: $input) {\n    video {\n      rawId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "19951310bb60f5cfce06691138239ca6";

export default node;
